import { createFileRoute } from '@tanstack/react-router'
import CreateMockExam from '@/features/create-mock-exam'

export const Route = createFileRoute(
  '/_authenticated/create-mock-exam/$moduleId'
)({
  component: CreateMockExamWrapper,
})

function CreateMockExamWrapper() {
  const { moduleId } = Route.useParams() as {
    moduleId: string
  }
  return <CreateMockExam key={`${moduleId}`} moduleId={moduleId} />
}

export default Route
